import { ActionReducerMap, createFeatureSelector, createReducer } from '@ngrx/store'

export interface ApiState {
  testProperty: string //placeholder
}

export const ApiReducers: ActionReducerMap<ApiState> = {
  testProperty: createReducer(''), // placeholder
}

export const selectApiState = createFeatureSelector<ApiState>('api')
